import "./App.scss";
import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonRouterOutlet,
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { useState, useEffect, useRef } from 'react';
import { AppContext, ExAppContext } from "./Context";
import { MemberUser_TypeMap, App_ViewModeMap, System_DeviceOrientationMap } from "./assets/keyMap";
import React, { Component } from 'react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

//pages
import Splash from "./pages/Splash";
import BlankPage from "./pages/BlankPage";
import ViewNotifications from "./pages/ViewNotifications";
import Login from './pages/Login';
import MemberHome from './pages/home/MemberHome';
// import PrimaryMemberHome from './pages/home/PrimaryMemberHome';
// import SecondaryMemberHome from './pages/home/SecondaryMemberHome';
import CommitteeHome from './pages/home/CommitteeHome';
import Profile from './pages/profile/Profile';
// import EditProfile from './pages/profile/EditProfile'; ---deprecated
import ChangePassword from './pages/profile/ChangePassword';
import ResetPin from "./pages/profile/ResetPin";
import ECert from "./pages/profile/ECert";
// import MembershipRenewal from "./pages/profile/MembershipRenewal"; ---deprecated
// import SecondaryAccount from "./pages/profile/SecondaryAccount"; ---deprecated
// import ViewEvents from './pages/event/ViewEvents'; --deprecated change to MyEvents
import ViewEventGallery from './pages/event/ViewEventGallery';
import ViewDocuments from './pages/ViewDocuments';
// import DiscoverEvents from './pages/event/DiscoverEvents'; ---derpecated
import Events from './pages/event/Events';
import MyEvents from './pages/event/MyEvents';
import EventRegistrations from './pages/event/EventRegistrations';
import Miscellaneous from "./pages/Miscellaneous";
import ViewMeetings from './pages/committee/ViewMeetings';
import ViewPolls from './pages/committee/ViewPolls';
import MembersList from './pages/MembersList';
import ManageMembership from './pages/profile/ManageMembership';
import ManageNotifications from "./pages/committee/ManageNotifications";
import ManageEventAttachments from "./pages/event/MangeEventAttachments";
import TestCollage from './pages/TestCollage';
import SocialMedia from './pages/SocialMedia';

//controllers
import FrameComponentsController from "./controllers/FrameComponentsController";
import GeneralComponentsController from './controllers/GeneralComponentsController';
import AppController from "./controllers/AppController";
import DatabaseRequestController from './controllers/DatabaseRequestController';
import PhoneStorageController from "./controllers/PhoneStorageController";
import WatchSyncController from "./controllers/WatchSyncController";
import RouteController from './controllers/RouteController';
import KeyboardController from "./controllers/KeyboardController";
import NotificationsController from "./controllers/NotificationsController";

//components
// import Header from './components/Header';
// import NavBar from './components/NavBar';
// import Footer from './components/Footer';

//classes
// import Sponsor from './classes/sponsor'; ---deprecated of unused
import Member from './classes/member';
import MembershipRegistration from "./exClasses/membershipRegistration";
import MembershipContract from "./exClasses/membershipContract";
import MemberUser from './classes/memberUser';
import Broadcast from "./classes/broadcast";
import Event from './exClasses/event';
import EventRegistration from './exClasses/eventRegistration';
import MeetingInvitation from "./exClasses/meetingInvitation";
import EventCategory from './exClasses/eventCategory';
import CommitteeType from "./exClasses/committeeType";
import MemberType from './exClasses/memberType';
import MemberFee from './exClasses/memberFee';
import InvoiceNote from './exClasses/invoiceNote';
import Document from "./exClasses/document";
import DocumentCategory from "./exClasses/documentCategory";
import EventItem from './exClasses/eventItem';
import Poll from './exClasses/poll';
import Notification from './classes/notification';
import { isPlatform } from "@ionic/react";

setupIonicReact({ swipeBackEnabled: false, swipeGesture: false });

const App: React.FC = () => {
  //appsetup
  // const dburl = 'https://www.gettix2u.com/ppkm/mobile_backend/scripts/'; ---deprecated to new url
  const dburl = 'https://www.ppkm.org.my/mobile_backend/scripts/';
  const secret = 'ppkm_14082024_mobile';
  const appLink = { android: 'https://play.google.com/store/apps/details?id=com.neudimenxion.PPKM_SuperApp&hl=en', ios: 'https://apps.apple.com/ma/app/ppkm-super-app/id6736516881' };
  const appBuild = '75';
  const [deviceOrientation, SetDeviceOrientation] = useState<number>(System_DeviceOrientationMap.LANDSCAPE);
  const [safeArea, SetSafeArea] = useState({ top: 0, right: 0, bottom: 0, left: 0 } as any);
  const [language, SetLanguage] = useState('en');
  // const [newbiePrompt, SetNewbiePrompt] = useState(false); ---deprecated
  const [rememberedEmail, SetRememberedEmail] = useState('');
  const [rememberedPassword, SetRememberedPassword] = useState('');
  const [usersAgreement, SetUsersAgreement] = useState(false);
  //frame components, header - navBar - footer - sideBar
  const [headerShouldHide, SetHeaderShouldHide] = useState(true);
  const [navBarShouldHide, SetNavBarShouldHide] = useState(true);
  const [sideBarShouldHide, SetSideBarShouldHide] = useState(true);
  const [headerBackAction, SetHeaderBackAction] = useState<any>(() => { });
  const [headerTitle, SetHeaderTitle] = useState('');
  //popup message box
  const [popupMessage, SetPopupMessage] = useState('');
  const [popupButtons, SetPopupButtons] = useState<string[]>(['Ok']);
  const [popupActions, SetPopupActions] = useState<any[]>([() => { }]);
  //popup instruction box(tutorials)
  const [popupInstructions, SetPopupInstructions] = useState([] as string[]);
  const [popupPreviews, SetPopupPreviews] = useState([] as string[]);
  const [popupShouldSvgAnimations, SetPopupShouldSvgAnimations] = useState([] as string[]);
  const [popupInstructAction, SetPopupInstructAction] = useState<any>(() => { });
  //popup agreement box
  const [agreementMessage, SetAgreementMessage] = useState('');
  //otp screen
  const [otpTitle, SetOtpTitle] = useState('');
  const [otpVerificationCode, SetOtpVerificationCode] = useState('');
  const [otpSubject, SetOtpSubject] = useState('');
  const [otpMode, SetOtpMode] = useState<number>(0);
  const [otpResultAction, SetOtpResultAction] = useState<any>(null); //result function (result-status: bool, result-message: string)
  //wait screen
  const [waitScreenMessage, SetWaitScreenMessage] = useState('');
  const [waitScreenShouldShow, SetWaitScreenShouldShow] = useState(false);
  //PinNumberKeypad
  const [pinNumberVerificationKey, SetPinNumberVerificationKey] = useState('');
  const [pinNumberVerificationMessage, SetPinNumberVerificationMessage] = useState('');
  const [pinNumberSuccessAction, SetPinNumberSuccessAction] = useState({} as any);
  const [pinNumberResetPinAction, SetPinNumberResetPinAction] = useState({} as any);
  //keyboard control
  const [keyboardHeight, SetKeyboardHeight] = useState(0);
  //database controller
  // const [sponsors, SetSponsors] = useState<Sponsor[]>([] as Sponsor[]); ----deprecated of unused
  const databaseActionModeQueueRef = useRef([] as string[]);
  const [databaseActionModeQueue, SetDatabaseActionModeQueue] = useState(databaseActionModeQueueRef.current);
  const databaseActionParamsQueueRef = useRef([] as any[]);
  const [databaseActionParamsQueue, SetDatabaseActionParamsQueue] = useState(databaseActionParamsQueueRef.current);
  const [databaseResultAction, SetDatabaseResultAction] = useState<any>(null);
  const [databaseShouldShowWaitScreen, SetDatabaseShouldShowWaitScreen] = useState<boolean>(false);
  //phone storage controller
  const [storageRequestMode, SetStorageRequestMode] = useState(''); //get or set
  const [storageRequestParams, SetStorageRequestParams] = useState<any[]>([]);
  const [storageRequestResultAction, SetStorageRequestResultAction] = useState<any>(null);
  //user
  const [user, SetUser] = useState<MemberUser>({} as MemberUser);
  //app controller
  const [appStateChangeWatch, SetAppStateChangeWatch] = useState(true);
  const [appListenerActions, SetAppListenerActions] = useState([] as any[]);
  //route controller
  const [routeControlHistoryStacks, SetRouteControlHistoryStacks] = useState([] as string[]);
  const [routeControlHistoryBackAction, SetRouteControlHistoryBackAction] = useState({} as any);
  // const [routeControlHistoryStayAction, SetRouteControlHistoryStayAction] = useState({} as any); ---deprecated
  //for notifications controller
  const [notificationMode, SetNotificationMode] = useState<number>(0);
  const [localNotifications, SetLocalNotifications] = useState([] as Notification[]);
  const [shouldClearAllPendings, SetShouldClearAllPendings] = useState<boolean>(false);
  const [shouldShowNotices, SetShouldShowNotices] = useState<boolean>(true);

  //exAppContext
  const [viewMode, SetViewMode] = useState<number>(App_ViewModeMap.MEMBER);
  // const [currentSelectedEvent, SetCurrentSelectedEvent] = useState<Event>({} as Event); ---deprecated of unused
  const [currentSelectedMemberUser, SetCurrentSelectedMemberUser] = useState<MemberUser>({} as MemberUser);
  const [committeeTypes, SetCommitteeTypes] = useState<CommitteeType[]>([] as CommitteeType[]);
  const [eventCategories, SetEventCategories] = useState<EventCategory[]>([] as EventCategory[]);
  const [memberTypes, SetMemberTypes] = useState<MemberType[]>([] as MemberType[]);
  const [memberFees, SetMemberFees] = useState<MemberFee[]>([] as MemberFee[]);
  const [invoiceNotes, SetInvoiceNotes] = useState<InvoiceNote[]>([] as InvoiceNote[]);
  const [documentCategories, SetDocumentCategories] = useState<DocumentCategory[]>([] as DocumentCategory[]);
  const [broadcasts, SetBroadcasts] = useState<Broadcast[]>([] as Broadcast[]);
  const [membershipRegistration, SetMembershipRegistration] = useState<MembershipRegistration>({} as MembershipRegistration);
  const [membership, SetMembership] = useState<Member>({} as Member);
  const [membershipUsers, SetMembershipUsers] = useState<MemberUser[]>([] as MemberUser[]);
  const [membershipContracts, SetMembershipContracts] = useState<MembershipContract[]>([] as MembershipContract[]);
  // const [onGoingEvents, SetOnGoingEvents] = useState<Event[]>([] as Event[]); ---deprecated of unused
  const [userEventRegistrations, SetUserEventRegistrations] = useState<EventRegistration[]>([] as EventRegistration[]);
  // const [userEvents, SetUserEvents] = useState<Event[]>([] as Event[]); -- deprecated, renamed to userUpcomingEvents
  const [userUpcomingEvents, SetUserUpcomingEvents] = useState([] as Event[]);
  const [viewableDocuments, SetViewableDocuments] = useState<Document[]>([] as Document[]);
  const [allDocuments, SetAllDocuments] = useState<Document[]>([] as Document[]);
  // const [allEvents, SetAllEvents] = useState<Event[]>([] as Event[]); ---deprecated
  const [allCommitteeMembers, SetAllCommitteeMembers] = useState<MemberUser[]>([] as MemberUser[]);
  const [meetingInvitations, SetMeetingInvitations] = useState<MeetingInvitation[]>([] as MeetingInvitation[]);
  const [acceptedUpcomingMeetings, SetAcceptedUpcomingMeetings] = useState<Event[]>([] as Event[]);
  // const [unvotedUpcomingPolls, SetUnvotedUpcomingPolls] = useState<Poll[]>([] as Poll[]); ---deprecated
  const [unvotedCurrentAndVotedPolls, SetUnvotedCurrentAndVotedPolls] = useState<Poll[]>([] as Poll[]);
  const [hostedMeetings, SetHostedMeetings] = useState<Event[]>([] as Event[]);
  const [hostedMeetingInvitations, SetHostedMeetingInvitations] = useState<MeetingInvitation[]>([] as MeetingInvitation[]);
  const [hostedMeetingAttachments, SetHostedMeetingAttachments] = useState<EventItem[]>([] as EventItem[]);
  const [hostedPolls, SetHostedPolls] = useState<Poll[]>([] as Poll[]);
  const [ongoingEvents, SetOngoingEvents] = useState<Event[]>([] as Event[]);


  // const [membership, SetMembership] = useState<Member>({} as Member);
  // const [membershipRegistration, SetMembershipRegistration] = useState<MembershipRegistration>({} as MembershipRegistration);
  // const [events, SetEvents] = useState<Event[]>([] as Event[]);
  // const [userEvents, SetUserEvents] = useState<Event[]>([] as Event[]);
  // const [userEventRegistrations, SetUserEventRegistrations] = useState<EventRegistration[]>([] as EventRegistration[]);

  // const [currentSelectedMemberUser, SetCurrentSelectedMemberUser] = useState({} as MemberUser);
  // const [viewMode, SetViewMode] = useState<number>(App_ViewModeMap.MEMBER);
  // const [meetingInvitations, SetMeetingInvitations] = useState<MeetingInvitation[]>([] as MeetingInvitation[]);
  // const [hostedMeetings, SetHostedMeetings] = useState<Event[]>([] as Event[]);
  // const [hostedMeetingInvitations, SetHostedMeetingInvitations] = useState<MeetingInvitation[]>([] as MeetingInvitation[]);
  // const [committeeMembers, SetCommitteeMembers] = useState<MemberUser[]>([] as MemberUser[]);
  // const [eventCategories, SetEventCategories] = useState<EventCategory[]>([] as EventCategory[]);
  // // const [payments, SetPayments] = useState<Payment[]>([] as Payment[]);
  // const [membershipContracts, SetMembershipContracts] = useState<MembershipContract[]>([] as MembershipContract[]);

  //test
  useEffect(() => {
    console.log('AppTest: ' + JSON.stringify(deviceOrientation));
  }, [deviceOrientation]);

  //android safe-area bottom workaround
  useEffect(() => {
    if(isPlatform('android')) {
      const bottomInset = window.screen.height - window.innerHeight;
      document.documentElement.style.setProperty('--safe-area-inset-bottom', bottomInset + 'px');
    }
  }, []);

  //provides function
  const ExContextProvider = (element: any) => {
    return (
      <ExAppContext.Provider value={{
        viewMode, SetViewMode,
        // currentSelectedEvent, SetCurrentSelectedEvent, ---deprecated of unused
        currentSelectedMemberUser, SetCurrentSelectedMemberUser,
        committeeTypes, SetCommitteeTypes,
        eventCategories, SetEventCategories,
        memberTypes, SetMemberTypes,
        memberFees, SetMemberFees,
        invoiceNotes, SetInvoiceNotes,
        documentCategories, SetDocumentCategories,
        broadcasts, SetBroadcasts,
        membershipRegistration, SetMembershipRegistration,
        membership, SetMembership,
        membershipUsers, SetMembershipUsers,
        membershipContracts, SetMembershipContracts,
        // onGoingEvents, SetOnGoingEvents, ---deprecated of unused
        userEventRegistrations, SetUserEventRegistrations,
        userUpcomingEvents, SetUserUpcomingEvents,
        viewableDocuments, SetViewableDocuments,
        allDocuments, SetAllDocuments,
        // allEvents, SetAllEvents, ---deprecated
        allCommitteeMembers, SetAllCommitteeMembers,
        meetingInvitations, SetMeetingInvitations,
        acceptedUpcomingMeetings, SetAcceptedUpcomingMeetings,
        // unvotedUpcomingPolls, SetUnvotedUpcomingPolls,
        unvotedCurrentAndVotedPolls, SetUnvotedCurrentAndVotedPolls,
        hostedMeetings, SetHostedMeetings,
        hostedMeetingInvitations, SetHostedMeetingInvitations,
        hostedMeetingAttachments, SetHostedMeetingAttachments,
        hostedPolls, SetHostedPolls,
        ongoingEvents, SetOngoingEvents
      }}>
        {element}
      </ExAppContext.Provider>
    );
  }

  return (
    <AppContext.Provider value={{
      /* settings */
      dburl, secret, appLink, appBuild,
      deviceOrientation, SetDeviceOrientation,
      // newbiePrompt, SetNewbiePrompt, ---deprecated
      rememberedEmail, SetRememberedEmail,
      rememberedPassword, SetRememberedPassword,
      usersAgreement, SetUsersAgreement,
      safeArea, SetSafeArea,

      headerShouldHide, SetHeaderShouldHide,
      navBarShouldHide, SetNavBarShouldHide,
      sideBarShouldHide, SetSideBarShouldHide,
      language, SetLanguage,
      headerBackAction, SetHeaderBackAction,
      headerTitle, SetHeaderTitle,
      popupMessage, SetPopupMessage,
      popupButtons, SetPopupButtons,
      popupActions, SetPopupActions,
      popupInstructions, SetPopupInstructions,
      popupPreviews, SetPopupPreviews,
      popupShouldSvgAnimations, SetPopupShouldSvgAnimations,
      popupInstructAction, SetPopupInstructAction,
      agreementMessage, SetAgreementMessage,
      otpTitle, SetOtpTitle,
      otpVerificationCode, SetOtpVerificationCode,
      otpSubject, SetOtpSubject,
      otpMode, SetOtpMode,
      otpResultAction, SetOtpResultAction,
      pinNumberVerificationKey, SetPinNumberVerificationKey,
      pinNumberVerificationMessage, SetPinNumberVerificationMessage,
      pinNumberSuccessAction, SetPinNumberSuccessAction,
      pinNumberResetPinAction, SetPinNumberResetPinAction,
      waitScreenMessage, SetWaitScreenMessage,
      waitScreenShouldShow, SetWaitScreenShouldShow,
      keyboardHeight, SetKeyboardHeight,
      // sponsors, SetSponsors, ---deprecated of unused
      // databaseActionMode, SetDatabaseActionMode,
      // SetDatabaseActionParams,
      databaseActionModeQueueRef, databaseActionModeQueue, SetDatabaseActionModeQueue,
      databaseActionParamsQueueRef, databaseActionParamsQueue, SetDatabaseActionParamsQueue,
      databaseResultAction,
      databaseShouldShowWaitScreen, SetDatabaseShouldShowWaitScreen,
      storageRequestMode, SetStorageRequestMode,
      storageRequestParams, SetStorageRequestParams,
      storageRequestResultAction, SetStorageRequestResultAction,
      user, SetUser,
      broadcasts, SetBroadcasts,
      appStateChangeWatch, SetAppStateChangeWatch,
      appListenerActions, SetAppListenerActions,
      routeControlHistoryStacks, SetRouteControlHistoryStacks,
      routeControlHistoryBackAction, SetRouteControlHistoryBackAction,
      notificationMode, SetNotificationMode,
      localNotifications, SetLocalNotifications,
      shouldClearAllPendings, SetShouldClearAllPendings,
      shouldShowNotices, SetShouldShowNotices
      // routeControlHistoryStayAction, SetRouteControlHistoryStayAction ---deprecated
    }}>
      <IonApp className={'App ' + (keyboardHeight > 0 ? 'keyboard' : '')}
        // style={{
        //   height: `calc(100vh - ${keyboardHeight}px - ${safeArea['top']}px - ${safeArea['bottom']}px)`,
        //   width: `calc(100vw - ${safeArea['left']}px - ${safeArea['right']}px)`,
        //   top: `${safeArea['top']}px`,
        //   left: `${safeArea['left']}px`
        // }
        style={
          { height: `calc(100vh - ${safeArea['top']}px - ${safeArea['bottom']}px - ${keyboardHeight}px)` }
        }
      >
        {/** For Desktop Build */}
        <IonReactRouter basename="/ppkm-web">
        {/** For Mobile Build */}
        {/* <IonReactRouter> */}
          <IonRouterOutlet {...({} as any)} className='IonRouterOutlet' style={{ width: 'auto', height: 'auto', overflowX: 'hidden', overflowY: 'auto' }}>
            <Route exact path='/Splash' render={() => <Splash splashDelayAfterAnimation={0} />} />
            <Route exact path='/Blank' render={() => <BlankPage />} />
            <Route exact path='/ViewNotifications' render={() => ExContextProvider(<ViewNotifications />)} />
            <Route exact path='/Login' render={() => ExContextProvider(<Login />)} />
            <Route exact path='/Home' render={() => ExContextProvider(<MemberHome />)} />
            {/*<Route exact path="/Splash"><Splash splashDelayAfterAnimation={0} /></Route>
            <Route exact path="/Blank"><BlankPage /></Route>
            <Route exact path="/ViewNotifications">{ExContextProvider(<ViewNotifications />)}</Route>
            <Route exact path="/Login">{ExContextProvider(<Login />)}</Route>
            <Route exact path="/Home">{ExContextProvider(<MemberHome />)}</Route> ---deprecated*/}

            {/** Member's Pages */}
            <Route exact path='/Profile' render={() => ExContextProvider(<Profile />)} />
            <Route exact path='/ManageMembership' render={() => ExContextProvider(<ManageMembership />)} />
            <Route exact path='/ChangePassword' render={() => <ChangePassword />} />
            <Route exact path='/ResetPin' render={() => <ResetPin />} />
            <Route exact path='/ECert' render={() => ExContextProvider(<ECert />)} />
            <Route path='/ViewEventGallery' render={() => ExContextProvider(<ViewEventGallery />)} />
            <Route path='/ViewDocuments' render={() => ExContextProvider(<ViewDocuments />)} />
            <Route path='/Events' render={() => ExContextProvider(<Events />)} />
            <Route path='/MyEvents' render={() => ExContextProvider(<MyEvents />)} />
            <Route path='/EventRegistrations' render={() => ExContextProvider(<EventRegistrations />)} />
            <Route path='/MembersList' render={() => ExContextProvider(<MembersList />)} />
            <Route path='/Miscellaneous' render={() => <Miscellaneous />} />
            <Route path='/SocialMedia' render={() => <SocialMedia />}/>

            {/*<Route exact path="/Profile">{ExContextProvider(<Profile />)}</Route>
            <Route exact path='/ManageMembership'>{ExContextProvider(<ManageMembership />)}</Route>
            <Route exact path='/ChangePassword'><ChangePassword /></Route>
            <Route exact path='/ResetPin'><ResetPin /></Route>
            <Route path="/ViewEventGallery">{ExContextProvider(<ViewEventGallery />)}</Route>
            <Route path='/ViewDocuments'>{ExContextProvider(<ViewDocuments />)}</Route>
            <Route path="/Events">{ExContextProvider(<Events />)}</Route>
            <Route path="/MyEvents">{ExContextProvider(<MyEvents />)}</Route>
            <Route path="/EventRegistrations">{ExContextProvider(<EventRegistrations />)}</Route>
            <Route path="/MembersList">{ExContextProvider(<MembersList />)}</Route>
            <Route path="/Miscellaneous"><Miscellaneous /></Route> ---deprecated*/}

            {/** Committee's  Pages */}
            <Route path='/ViewMeetings' render={() => ExContextProvider(<ViewMeetings />)} />
            <Route path='/ViewPolls' render={() => ExContextProvider(<ViewPolls />)} />
            <Route path='/ManageNotifications' render={() => ExContextProvider(<ManageNotifications />)} />
            <Route path='/ManageEventAttachments' render={() => ExContextProvider(<ManageEventAttachments />)} />
            <Route path='/TestCollage' render={() => <TestCollage />} />

            {/* <Route path="/ViewMeetings">{ExContextProvider(<ViewMeetings />)}</Route>
            <Route path="/ViewPolls">{ExContextProvider(<ViewPolls />)}</Route>
            <Route path="/ManageNotifications">{ExContextProvider(<ManageNotifications />)}</Route>
            <Route path="/ManageEventAttachments">{ExContextProvider(<ManageEventAttachments />)}</Route>
            <Route path="/TestCollage"><TestCollage /></Route> */}

          </IonRouterOutlet>
          {ExContextProvider(<FrameComponentsController />)}
          <GeneralComponentsController />
          {ExContextProvider(<AppController />)}
          <DatabaseRequestController
            databaseActionModeQueueRef={databaseActionModeQueueRef} databaseActionModeQueue={databaseActionModeQueue} SetDatabaseActionModeQueue={SetDatabaseActionModeQueue}
            databaseActionParamsQueueRef={databaseActionParamsQueueRef} databaseActionParamsQueue={databaseActionParamsQueue} SetDatabaseActionParamsQueue={SetDatabaseActionParamsQueue}
            databaseResultAction={databaseResultAction} SetDatabaseResultAction={SetDatabaseResultAction}
            databaseShouldShowWaitScreen={databaseShouldShowWaitScreen}
          />
          <PhoneStorageController
            storageRequestMode={storageRequestMode} SetStorageRequestMode={SetStorageRequestMode}
            storageRequestParams={storageRequestParams} SetStorageRequestParams={SetStorageRequestParams}
            storageRequestResultAction={storageRequestResultAction} SetStorageRequestResultAction={SetStorageRequestResultAction}
          />
          {ExContextProvider(<WatchSyncController />)}
          {ExContextProvider(<RouteController />)}
          <KeyboardController SetKeyboardHeight={SetKeyboardHeight} />
          <NotificationsController
            SetNotificationMode={SetNotificationMode}
            localNotifications={localNotifications} SetLocalNotifications={SetLocalNotifications}
            shouldClearAllPendings={shouldClearAllPendings} SetShouldClearAllPendings={SetShouldClearAllPendings}
          />
          <div id='invoice-template' className='invoice-template' />
        </IonReactRouter>
      </IonApp>
    </AppContext.Provider>
  );
};

export default App;
